import { type ReactNode } from 'react'

// Small ⓘ icon with a styled hover/focus tooltip. The info text is passed as
// CHILDREN (not a text="…" prop), so it can contain straight quotes, line breaks
// (<br/>) or emphasis (<b>…</b>) without the JSX attribute-quote pitfalls.
// Keyboard-accessible: the icon is focusable and the bubble shows on focus too.
export default function InfoTip({ children }: { children: ReactNode }) {
    return (
        <span className="infotip" tabIndex={0}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}
                strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
            <span className="infotip-bubble" role="tooltip">{children}</span>
        </span>
    )
}
